'use client';

import { useEffect } from 'react';

import { usePathname } from 'next/navigation';

import useUser from 'hooks/useUser';

const TIMEOUT = 60 * 1000; // 60 seconds

function OnlineCheck() {
  const { user } = useUser();
  const pathname = usePathname();

  useEffect(() => {
    const intervalId = setInterval(async () => {
      try {
        const result = await fetch('/api/online-status');
        if (result.status !== 200) {
          // user was offline, now online
          window.location.assign('/?offline=true');
        }
      } catch (e) {
        console.log('check failed');
      }
    }, TIMEOUT); // 30 seconds

    if (!user) {
      clearInterval(intervalId);
    }
    // Avoid redirecting when in auth page
    if (pathname?.includes('auth')) {
      clearInterval(intervalId);
    }
    return () => clearInterval(intervalId);
  }, [user, pathname]);
  return null;
}

export default OnlineCheck;
